import React from 'react';
import ListTeamsItemStatusIcons from './ListTeamsItemStatusIcons';
import ListTeamsItemStatusComment from './ListTeamsItemStatusComment';
var selfStyles = require('./styles.scss');
var ListTeamsItemStatus = function (props) {
    if (!props.teamScore) {
        return null;
    }
    return (React.createElement("span", { className: selfStyles.iconStatus },
        props.teamScore.statusIcons && (React.createElement(ListTeamsItemStatusIcons, { teamScore: props.teamScore })),
        props.teamScore.statusIcons && (React.createElement(ListTeamsItemStatusComment, { isActive: props.isActive, teamScore: props.teamScore }))));
};
export default ListTeamsItemStatus;



//////////////////
// WEBPACK FOOTER
// ./src/imports/components/Scoreboard/components/ListTeamsItemStatus.tsx
// module id = 663
// module chunks = 0